import { makeStyles } from "@mui/styles"

export const dialogStyles = makeStyles(() => ({
  noItems: {
    "& [class*=MuiSvgIcon]": {
      color: "#8e818c !important",
      height: "70px",
      marginBottom: "24px",
      width: "70px",
    },

    alignItems: "center",
    color: "#8e818c",
    display: "flex",
    flexDirection: "column",
    fontWeight: 700,
    opacity: 0.26,
    placeContent: "center",
  },
  filterForm: {
    width: "360px",
  },
  table: ({ minHeight, width }) => ({
    display: "flex",
    flexFlow: "column",
    flex: 1,

    "& .MuiToolbar-root": {
      background: "rgb(244 244 244) !important",
    },
    "& .MuiDataGrid-columnHeaders": {
      borderBottom: "1px solid #ECECEC !important",
    },
    "& .MuiDataGrid-main": {
      border: "1px solid #ECECEC !important",
    },
    "& .MuiDataGrid-menuIcon": {
      display: "none !important",
    },
    "& .MuiFilledInput-root, & .searchField, & .MuiFilledInput-root": {
      background: "#d3d3d3 !important",
      borderRadius: "4px",
    },
    "& [class*=MuiDataGrid]": {
      "& [class*=row]": {
        "& [data-field*=avatar]": {
          padding: "0 !important",
        },
        "&:last-of-type": {
          "& [class*=cell]": {
            border: "none",
          },
        },
      },

      border: "none",
    },
    "& [class*=MuiDataGrid-autoHeight]": {
      minHeight: "unset !important",
    },
    "& [class*=MuiDataGrid-main]": {
      "& .MuiDataGrid-virtualScroller": {
        minHeight: "205px",
        // height: "205px !important",
      },

      "& > div:nth-child(2)": {
        height: "261px !important",
      },
    },
    "& [class*=MuiPaper]": {
      backgroundColor: "transparent",
      boxShadow: "none",
      minHeight: "unset",
      padding: 0,
      border: "none",
    },
    "& [class*=MuiToolbar]": {
      background: "#ececec",
    },
    "& [class*=footerContainer]": {
      display: "none",
    },
    "& [class*=virtualScrollerContent]": {
      height: "264px !important",
    },
    "& [class*=virtualScrollerRenderZone]": {
      "& [class*=notification]": {
        display: "none !important",
      },
      backgroundColor: "#FFFFFF",
    },

    minHeight,
    width: width || "100%",
  }),
  tableTotalItems: {
    marginTop: "6px",
  },
}))
